import axios from './axios'

export function getDashboardCount() {
  return axios({
    method: "get",
    url: '/api/v1/dashboard/count/'
  })
}


